import { NullableFormValue, ValueConverter } from "../index";


class EidConverter implements ValueConverter<string, string> {
	toData( text: NullableFormValue<string, string> ): NullableFormValue<string, string> {
		if ( text )
			text = text.toString().replace( /\D/g, "" );
		return text;
	}

	fromData( data: NullableFormValue<string, string> ): NullableFormValue<string, string> {
		if ( data )
			data = data.toString().replace( /[^0-9]*/g, "" );
		return data;
	}
}

const eidConverter = new EidConverter();
export default eidConverter;
